import ResetPassword from './ResetPassword.js';

export default ResetPassword;
